import { render, staticRenderFns } from "./DoctorTargetList.vue?vue&type=template&id=23ab353e&scoped=true"
import script from "./DoctorTargetList.vue?vue&type=script&lang=js"
export * from "./DoctorTargetList.vue?vue&type=script&lang=js"
import style0 from "./DoctorTargetList.vue?vue&type=style&index=0&id=23ab353e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ab353e",
  null
  
)

export default component.exports